import { ContentType } from './datalayerPusher';

interface MarTechWindow extends Window {
  mtam?: {
    sendDownloadEventToCdp: typeof sendDownloadEventToCdp;
    sendFavoriteSaveEventToCdp: typeof sendFavoriteSaveEventToCdp;
  };
}

declare let window: MarTechWindow;

export function sendDownloadEventToCdp(contentType: ContentType, fileExtension: string) {
    if (window.mtam && typeof window.mtam.sendDownloadEventToCdp === 'function') {
        window.mtam.sendDownloadEventToCdp(contentType, fileExtension);
    }
}

export function sendFavoriteSaveEventToCdp(contentType: ContentType) {
    if (window.mtam && typeof window.mtam.sendFavoriteSaveEventToCdp === 'function') {
        window.mtam.sendFavoriteSaveEventToCdp(contentType);
    }
}
